import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../../../shared/_TBComponents/Button';
import SharedModal from '../../../../shared/_TBComponents/Modal';
import Text from '../../../../shared/_TBComponents/Text';

const CANCEL_BORDER_COLOR = '#dddddd';

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Title = styled('h2')`
  color: #000000;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 12px;
  text-align: center;
`;

const Buttons = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// Confirms before joining a Google-matched account to IDNTY - a Google
// account picker is a single, easy-to-mis-click action, unlike typing a
// specific email/password. Not shown for ALREADY_MEMBER, since nothing is
// mutated on that path.
const IdntyGoogleJoinModal = ({
  email, isOpen, isSubmitting, onCancel, onConfirm,
}) => (
  <SharedModal
    customBorderRadius='12px'
    customButton
    customMaxWidth='440px'
    customMinHeight='auto'
    customPadding='32px'
    hideTitle
    isOpen={isOpen}
    onRequestClose={onCancel}
    shouldCloseOnOverlayClick={!isSubmitting}
  >
    <Content>
      <Title>Join IDNTY with this Google account?</Title>
      <Text
        styledTextProps={{
          color: '#444444',
          fontSize: '14px',
          fontWeight: '500',
          mb: '24px',
          textAlign: 'center',
        }}
      >
        {email}
        {' '}
        is linked to an existing TeamBuildr account. Continuing will
        connect that account to IDNTY.
      </Text>
      <Buttons>
        <Button
          bgColor='#00F5F5'
          disabled={isSubmitting}
          fontSize='14px'
          fullWidth
          isLoading={isSubmitting}
          large
          lightSpinner
          name='Confirm'
          noBorder
          onClick={onConfirm}
          rounded
          txtColor='#000000'
          type='button'
          upperCase
        />
        <Button
          bgColor='#ffffff'
          borderColor={CANCEL_BORDER_COLOR}
          disabled={isSubmitting}
          fontSize='14px'
          fullWidth
          large
          name='Cancel'
          onClick={onCancel}
          rounded
          txtColor='#444444'
          type='button'
          upperCase
        />
      </Buttons>
    </Content>
  </SharedModal>
);

IdntyGoogleJoinModal.propTypes = {
  email: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

IdntyGoogleJoinModal.defaultProps = {
  email: '',
  isSubmitting: false,
};

export default IdntyGoogleJoinModal;
